module.exports = __webpack_public_path__ + "img/revenuesTypes.12a72d28.svg";